import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectionManager from '../../../app/assets/js/shared/selections';
import NodeContentHeaderTools from '../NodeContentHeaderTools';
import TeacherPanelIcon from '../../../public/assets/images/theme-2/icons/link_arrow_green.svg';

import { TopSection, TitleWrapper, NodeIcon, NodeTitle, TeacherPanelLink } from './styles';

const NodeContentTopSection = ({
  panel,
  nodeType,
  showFullScreenTool = false,
  showVoiceOverTool = false,
  showTeacherPanelLink = false,
  showDyslexicFontTool = true,
  sessionId,
  nodeId,
  viewer,
  userToken,
  nodeData,
  title,
}) => {
  const getKey = (type) => {
    switch (type) {
      case 'private_blog':
        return 'logbook';
      case 'public_blog':
        return 'noticeboard';
      default:
        return type;
    }
  };

  const nodeIcon = `/assets/images/theme-2/icons/node-pane/${nodeType}.svg`;
  const nodeTitle = i18n.__(`activity_${getKey(nodeType)}_name`);

  useEffect(() => {
    const initializeSelections = async () => {
      if (viewer && viewer.supportsCommunication()) {
        window.selectionManager = new SelectionManager();
        window.selectionManager.init({
          viewer,
          commentInstance: viewer.comments,
        });
      }
    };
    initializeSelections();
  }, []);

  const gotoTeacherPanel = () => {
    const teacherPanelPath = window.location.pathname.includes('teacher_panel') ? '' : 'teacher_panel';
    window.location.href = `/learn/${sessionId}/${teacherPanelPath}#${nodeId}/`;
  };

  const topSection = (
    <TopSection className={'ir-hide'}>
      <TitleWrapper>
        <NodeIcon src={nodeIcon} className={nodeType} />
        <NodeTitle>{nodeTitle}</NodeTitle>
        {showTeacherPanelLink && <TeacherPanelLink onClick={gotoTeacherPanel} src={TeacherPanelIcon} />}
      </TitleWrapper>
      <NodeContentHeaderTools
        userToken={userToken}
        nodeData={nodeData}
        title={title}
        panel={panel}
        viewer={viewer}
        showVoiceOverTool={showVoiceOverTool}
        showFullScreenTool={showFullScreenTool}
        showDyslexicFontTool={showDyslexicFontTool}
      />
    </TopSection>
  );

  return topSection;
};

export default NodeContentTopSection;

NodeContentTopSection.propTypes = {
  nodeType: PropTypes.string.isRequired,
  showFullScreenTool: PropTypes.bool,
  showVoiceOverTool: PropTypes.bool,
  showDyslexicFontTool: PropTypes.bool,
  showTeacherPanelLink: PropTypes.bool,
  sessionId: PropTypes.number,
  nodeId: PropTypes.string,
  panel: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  userToken: PropTypes.string.isRequired,
  nodeData: PropTypes.object,
};
